import { colors, grid_breakpoints } from "../../../../../../theme/theme";
import styled from "styled-components";

export const TableWrapper = styled.div`
	--side-padding: 40px;
	width: 100%;
	overflow-x: auto;

	table th {
		padding: 24px var(--side-padding);
	}

	table td {
		padding: 16px var(--side-padding);
	}

	.table > :not(:first-child) {
		border-top: 1px solid ${colors.greyscale.dark_grey};
	}

	@media (max-width: ${grid_breakpoints.lg}) {
		.material-table-column-deadline,
		.material-table-column-coupon {
			display: none;
		}
	}
	@media (max-width: ${grid_breakpoints.md}) {
		.material-table-column-date {
			display: none;
		}
	}
	@media (max-width: ${grid_breakpoints.sm}) {
		.material-table-column-type {
			display: none;
		}
	}

	.material-table-column-name{
		word-break: break-all;
	}
`;
